var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asidebody"},[_c('div',{staticClass:"nav-warpper"},_vm._l((_vm.titles),function(item,index){return _c('a',{key:index,class:_vm.isActive(index) ? 'activeClass' : ''},[_c('span',{on:{"click":function($event){return _vm.goto(index)}}},[_vm._v(" "+_vm._s(item)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }